import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
var $t = Vue.prototype.$t;
/**
 *  @description nodeType 等于4 审批人校验规则
 *  staffs（审批人）类型Array 校验其length是否大于 0
 */
export var approvalRules = {
  // 审批人为空校验
  specify_resign: [{
    validator: function validator(_, value, callback) {
      var isArray = Array.isArray(value);
      if (isArray && value.length) {
        return callback();
      }
      callback(new Error($t('work_rule_45')));
    },
    trigger: ['blur', 'change']
  }],
  // 审批人为空校验
  directorLevelPerson: [{
    validator: function validator(_, value, callback) {
      var isArray = Array.isArray(value);
      if (isArray && value.length) {
        return callback();
      }
      callback(new Error($t('work_rule_45')));
    },
    trigger: ['blur', 'change']
  }],
  val: [{
    validator: function validator(_, value, callback) {
      var isArray = Array.isArray(value);
      if (isArray && value.length) {
        return callback();
      }
      if (!isArray && value) return callback();
      callback(new Error($t('work_rule_80')));
    }
  }],
  settype: [{
    required: true,
    message: $t('221')
  }]
};

// 分支条件校验规则
export var condiyionRules = {
  condition: [{
    required: true,
    message: $t('221')
  }],
  operator: [{
    required: true,
    message: $t('221')
  }],
  value: [{
    validator: function validator(rule, value, callback) {
      if (value.value || value) {
        callback();
      } else return callback(new Error($t('221')));
    }
  }]
};

// 基础信息校验
export var baseRules = function baseRules(vm) {
  return {
    name: [{
      required: true,
      message: $t('f181bf5a')
    }],
    audit_type: [{
      required: true,
      message: $t('work_rule_35')
    }],
    group_id: [{
      required: true,
      message: $t('181bf5ae')
    }],
    allow_cancel_days: [{
      validator: function validator(_, value, callback) {
        if (vm.base.allow_type !== 3 || value) {
          callback();
        } else return callback(new Error($t('work_rule_54')));
      }
    }],
    visible: [{
      validator: function validator(_, value, callback) {
        var arr = [].concat(_toConsumableArray(value.staff), _toConsumableArray(value.department));
        if (value.toAll === 1 && !arr.length) return callback(new Error($t($t('i18n.1647917583450'))));
        callback();
      }
    }],
    is_allow_cancel: [{
      required: true,
      message: $t('work_rule_38')
    }]
  };
};

/**
 * @description 条件组校验函数
 * @override 适用于有条件逻辑的节点 如节点分支 发起人type为2时
 * @param { Array } branchGroups
 */
var verificationBranch = function verificationBranch(branchGroups) {
  var status = branchGroups.every(function (item) {
    return Boolean(item.length && item[0].operator.name);
  });
  return status;
};

/**
 * 审批节点或抄送节点校验
 * @param { Object } item
 * @returns { Boolean }
 */
var approvalVerification = function approvalVerification(item) {
  var type = item.type;
  var Obj = item.form[type === 1 ? 'auditor' : 'cc'];
  // 必须存在一个审批人 且不为空
  var state = Boolean(Obj.length && Obj[0].val);
  item.warning = _objectSpread(_objectSpread({}, item.warning), {}, {
    status: !state
  });
  return state;
};
// 分支节点校验  规则同上
var branchVerification = function branchVerification(item) {
  if (item.isDefault) {
    item.warning = {
      msg: $t('work_rule_55'),
      status: false
    };
    return true;
  }
  var state = verificationBranch(item.form);
  item.warning = {
    msg: $t('work_rule_55'),
    status: !state
  };
  return state;
};
var verificationMap = new Map([
// 审批人
[1, approvalVerification],
// 审批人
[2, approvalVerification],
// 条件
[3, branchVerification]]);

/**
 *  @description 节点校验
 *  @param { Object } sourceData
 *  @returns { Boolean }
 */
export var verification = function verification(sourceData) {
  // console.log(sourceData)
  var status = !sourceData.childNode ? !(sourceData.conditionList && sourceData.conditionList.length) : !sourceData.childNode;
  if (status) return;
  var arr = [sourceData];
  // 校验结果
  var resultState = true;
  // 深度遍历每个节点校验
  while (arr.length) {
    var current = arr.pop(); // 移除数组的最后一个元素，并返回该元素。
    var childNode = current.childNode;
    var conditionList = current.conditionList;
    if (childNode) arr.unshift(childNode);
    if (conditionList) conditionList.forEach(function (el) {
      return arr.unshift(el);
    });
    var verificationMethods = verificationMap.get(current.type);
    // 99为结束节点 默认没有配置函数
    if (verificationMethods && !verificationMethods(current)) resultState = false;
  }
  return resultState;
};